export default "__VITE_ASSET__d1a520c5__"